// extracted by mini-css-extract-plugin
export default {"menuItem":"AdminMenu-module__menuItem--ByRry","selected":"AdminMenu-module__selected--CjO8a"};